import Vue from "vue";
import Vuex from "vuex";

import state from "@/store/state.js";
import getters from "@/store/getters.js";
import mutations from "@/store/mutations.js";
import actions from "@/store/actions.js";

import tradingPair from "@/store/modules/tradingPair";
import balance from "@/store/modules/balance";
import openOrder from "@/store/modules/openOrder";
import orderBook from "@/store/modules/orderBook";
import orderHistory from "@/store/modules/orderHistory";
import tradeDetail from "@/store/modules/tradeDetail";
import position from "@/store/modules/position";
import trades from "@/store/modules/trades";
import depth from "./modules/depth";
import kLine from "./modules/kLine";
import funding from "@/store/modules/funding";
import connectWallet from "@/store/modules/connectWallet";
import tradingFees from "@/store/modules/tradingFees";
import nft from "@/store/modules/nft";

import dashboardMarkPriceLine from "./modules/dashboard/markPriceLine";
import dashboardPair from "./modules/dashboard/pair";
import dashboardPairMetrics from "./modules/dashboard/pairMetrics";
import dashboardIndexCompositionTable from "./modules/dashboard/IndexCompositionTable";

import rewardsBalance from "./modules/rewards/rewardsBalance";

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    tradingPair,
    balance,
    openOrder,
    orderBook,
    orderHistory,
    tradeDetail,
    position,
    trades,
    depth,
    kLine,
    funding,
    connectWallet,
    tradingFees,
    dashboardMarkPriceLine,
    dashboardPair,
    dashboardPairMetrics,
    dashboardIndexCompositionTable,
    rewardsBalance,
    nft,
  },
});
